<div *ngIf="column.includes('CurveSelection')" class="curve-selection-row">
  <div class="label signifyBookmd curve-label">Curve selections</div>
  <div class="curve-dropdown-wrapper">
        <select [(ngModel)]="ngModelval['CurveSelection']" class="select-curve"
            (change)="ZtvoutputvalueChange(ngModelval['CurveSelection'])">
            {{curve}}
            <option *ngFor="let curve of CurveSelection.enum" [ngValue]="curve">{{curveSurveyValues[curve]}}</option>
        </select>
    </div>
</div>

<div *ngIf=userSpecified>
  <div class="user-specified-title-block">
    <div class="label signifyBookmd">User specified curve:</div>
  </div>
  <div class="user-specified-content" id="userSpecifiedHeader">
    <div class="user-specified-grid">
      <div class="grid-column">
        <div class="label signifyBookmd user-specified-header">Dim level(%)</div>
        <div *ngFor="let item of dimLevelColumn">
          <div class="form-group">
            <input (input)="textValChanged($any($event.target).value, item)" (keypress)="numberOnly($event)"
                   [(ngModel)]="ngModelval[item]" [ngClass]="{'showingError': inputError[item]===true,'inputCssStandardNew': quickConfigvalue===true}" [value]="ngModelval[item]"
                   [id]="'ZtvOutput-' + item + '-input'"
                   class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
                   type="text"/>
          </div>
        </div>
      </div>
      <div class="grid-column">
        <div class="label signifyBookmd user-specified-header">0-10V / 1-10V</div>
        <div *ngFor="let items of outputVoltageColumn">
          <div class="form-group">
            <input (input)="textValChanged($any($event.target).value, items)" (keypress)="numberOnlyAlongWithDec($event)"
                   [(ngModel)]="ngModelval[items]" [ngClass]="{'showingError': inputError[items]===true,'inputCssStandard': quickConfigvalue===true}"
                   [value]="ngModelval[items]"
                   [id]="'ZtvOutput-' + items + '-input'"
                   class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
                   type="text"/>
          </div>
                </div>
            </div>
        </div>
    </div>
</div>
